import { useQueryUser } from 'graphql/query';
import { ReactChild } from 'react';
import { useNavigate } from 'react-router-dom';
import { paths } from 'routes';
import { RestrictedAccess } from 'components/RestrictedAccess/RestrictedAccess';

type AuthProviderProps = { children: ReactChild };

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const navigate = useNavigate();

  const { loading, data } = useQueryUser({
    fetchPolicy: 'network-only',
    onCompleted: ({ user }) => {
      const role = user?.roles?.[0];
      if (!role) {
        navigate(paths.auth.signin);
      }
    },
    onError: () => {
      navigate(paths.auth.signin);
    },
  });

  if (loading) {
    return null;
  }

  const user = data?.user;
  const isClientWithoutBusinessPartner =
    user?.roles?.includes('ROLE_USER') && !user?.businessPartner;

  if (isClientWithoutBusinessPartner) {
    return <RestrictedAccess />;
  }

  return <div>{children}</div>;
};
